import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {
  MultiSelectWithStaticOptionsStaticComponent
} from '../../../../components/form-inputs/multi-select-static-with-static-options/multi-select-with-static-options-static.component';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {SelectOption} from '../../../../components/form-inputs/form-group/form-group.component';
import {DateTime} from 'luxon';

@Component({
  selector: 'app-authenticated-time-tracking-overview-month-picker',
  templateUrl: './month-picker.component.html',
  imports: [
    MultiSelectWithStaticOptionsStaticComponent,
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class MonthPickerComponent {
  @Input({required: true}) yearControl!: FormControl;
  @Input() monthControl?: FormControl;

  public constructor(
    private readonly translate: TranslateService,
  ) {
  }

  public get monthSelectOptions(): SelectOption[] {
    return [
      {key: '1', value: this.translate.instant('misc.months.jan')},
      {key: '2', value: this.translate.instant('misc.months.feb')},
      {key: '3', value: this.translate.instant('misc.months.mar')},
      {key: '4', value: this.translate.instant('misc.months.apr')},
      {key: '5', value: this.translate.instant('misc.months.may')},
      {key: '6', value: this.translate.instant('misc.months.jun')},
      {key: '7', value: this.translate.instant('misc.months.jul')},
      {key: '8', value: this.translate.instant('misc.months.aug')},
      {key: '9', value: this.translate.instant('misc.months.sep')},
      {key: '10', value: this.translate.instant('misc.months.oct')},
      {key: '11', value: this.translate.instant('misc.months.nov')},
      {key: '12', value: this.translate.instant('misc.months.dec')},
    ];
  }

  public get yearSelectOptions(): SelectOption[] {
    const years: SelectOption[] = [];

    for (let i = DateTime.now().year - 10; i <= DateTime.now().year + 3; i++) {
      years.push({key: i.toString(), value: i.toString()});
    }

    return years;
  }
}
